import React from "react";
import { stringFilterOption } from "./filterOptionTypes";
import LayoutOptions from "venuescanner-js/react/components/LayoutOptions";
import classes from "./styles.module.scss";

export default stringFilterOption({
  ga: "layout",
  label: "Layout",
  title: "What kind of layout?",
  name: "layout",
  getValueLabel: (value) => (value?.length > 0 ? value.length : ""),
  defaultValue: "",
})((props) => (
  <div className={classes.LayoutFilterOption}>
    <LayoutOptions {...props} green />
  </div>
));
